module.exports = class Login {
	constructor (object) {
		this.username = object.username;
		this.password = object.password;
		this.sessionType = 'WEB';
		this.ip = '127.0.0.1';
	}
};
